/**
 * Pamięć samouczka „Pierwsze kroki” w przeglądarce, osobno dla każdego konta (klucz ze skrótu adresu e-mail,
 * bez samego adresu). Trzymamy tylko to, czego nie widać w danych konta: czy samouczek jest włączony, pominięty
 * albo skończony, wybrany krok, pominięte i potwierdzone kroki, odwiedzony kalendarz, cennik z chwili startu
 * kroku i zwinięcie panelu. Na innym urządzeniu kroki zrobione odhaczą się same z danych konta.
 * Każdy odczyt i zapis w try/catch: tryb prywatny albo zablokowane dane strony nie mogą wyłączyć serwisu.
 */
import { WERSJA } from './kroki'

export const PUSTA_PAMIEC = {
  v: WERSJA,
  stan: null, // null = jeszcze nie widział powitania, 'aktywny', 'pominiety', 'ukonczony'
  krok: null,
  pominiete: [],
  potwierdzone: [],
  odwiedzone: [],
  cennikStart: null,
  zwiniety: false,
}

// djb2: krótki, stały skrót adresu e-mail, żeby klucz nie zawierał samego adresu.
export const skrotKonta = (email) => {
  let h = 5381
  const s = String(email || '').trim().toLowerCase()
  for (let i = 0; i < s.length; i += 1) h = ((h << 5) + h + s.charCodeAt(i)) >>> 0 // eslint-disable-line no-bitwise
  return h.toString(36)
}

const klucz = (email) => `vv-samouczek:${skrotKonta(email)}`

export const czytajPamiec = (email) => {
  try {
    const zapis = JSON.parse(window.localStorage.getItem(klucz(email)) || 'null')
    if (!zapis || zapis.v !== WERSJA) return { ...PUSTA_PAMIEC }
    return { ...PUSTA_PAMIEC, ...zapis }
  } catch {
    return { ...PUSTA_PAMIEC }
  }
}

export const zapiszPamiec = (email, pamiec) => {
  try {
    window.localStorage.setItem(klucz(email), JSON.stringify({ ...pamiec, v: WERSJA }))
  } catch {
    // Brak pamięci przeglądarki: samouczek działa do końca wizyty.
  }
}
